import React from 'react';
const ReplenishmentStack = React.lazy(() => import('../components/digiArs/replenishment/replenishmentStack'));
const PlanningSettingStack = React.lazy(() => import('../components/digiArs/planningSettings/PlanningSettingsStack'));
const DigiArsStack = React.lazy(() => import('../components/digiArs/digiArsStack/index'))
const AdministrationStack = React.lazy(() => import('../components/administration/AdministrationStack'))
const MasterDataStack = React.lazy(() => import('../components/masterData/MasterDataStack'))
const SalesOrderStack = React.lazy(() => import('../components/salesOrder/SalesOrderStack'))
const SuperAdminStack = React.lazy(() => import('../components/superAdmin/SuperAdminStack'))
const AdminReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/adminReportsStack/AdminReportsStack'));
const ShipmentReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/shipmentReportsStack/ShipmentReportsStack'));
const DigivendStack = React.lazy(() => import('../components/digiVend/DigivendStack'));
const ReplenishmentReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/replenishmentReportsStack/ReplenishmentReportsStack'));
const InventoryManagementReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/inventoryManagementReportsStack/InventoryManagementReportsStack'))
const SalesReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/salesReportsStack/SalesReportsStack'))
const PurchaseReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/purchaseReportsStack/PurchaseReportsStack'))
const AccountingReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/accoutingReportStack/AccountingReportsStack'));
const StockReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/stockReportsStack/StockReportsStack'));
const LogisticsReportsStack = React.lazy(() => import('../components/reportsAndAnalytics/logisticsReportsStack/LogisticsReportsStack'));
const DigiProcStack = React.lazy(() => import('../components/digiProc/DigiProcStack'));
const DigiCatStack = React.lazy(() => import('../components/digicatalogue/DigiCatStack'))
const CustomerReportStack = React.lazy(() => import('../components/reportsAndAnalytics/customerReportsStack/CustomerReportStack'))
const GrievanceStack = React.lazy(() => import('../components/grievances/GrievanceStack'))

let reportStack = {
    "replenishmentReportsStack": [
        "/analytics/chooseStoreProfile",
        "/digiars/inventoryPlanningReport",
        "/inventoryPlanning/report4",
        "/digiars/sales/mbo/report",
        "/digiars/sales/weekly/report",
        "/digiars/stock/size/set/report",
        "/digiars/mboReport",
        "/inventoryPlanning/report2",
        "/inventoryPlanning/reordingReport",
        "/inventoryPlanning/transferOrderReport",
        "/inventoryPlanning/storePerformance",
        "/digiars/stock/size/set/report/v2",
        "/inventoryPlanning/:jobType/job/run/report",
        "/digiars/sales/price/movement/report",
        "/digiars/store/article/wise/requirement"
    ],
    "inventoryManagementReportsStack": [
        "/inventoryPlanning/sell/through/report",
        "/inventoryPlanning/catSizeReport",
        "/digiars/salesInventoryReport",
        "/inventoryPlanning/topBottomReports",
        "/inventoryPlanning/lastMonthReport",
        "/inventoryPlanning/topMovingReport",
        "/inventoryPlanning/saleContribution",
        "/inventoryPlanning/site/to/site/movement/report"
    ],
    "salesReportsStack": [
        "/analytics/retailerSalesStockItemReport",
        "/salesManagement/salesDrrMisReport",
        "/salesManagement/so/status/report",
        "/analytics/retailerSalesReport",
        "/analytics/retailerSalesReturnReport",
        "/inventoryPlanning/bill/report",
        "/analytics/retailerSalesReport/SALES_PERSON_REPORT",
        "/inventoryPlanning/report5",
        "/inventoryPlanning/report10",
        "/inventoryPlanning/report7",
        "/analytics/retailerGvAnalysis",
        "/inventoryPlanning/report3",
        "/analytics/retailerChannelWiseNetSalesAnalysis",
        "/analytics/hitLineReport",
        "/analytics/footfallReport",
        "/analytics/jistReport",
        "/inventoryPlanning/report6",
        "/inventoryPlanning/report9",
        "/inventoryPlanning/report8",
        "/inventoryPlanning/report1",
        "/analytics/retailerSalesReport/ENT_SALES_ITEM_REPORT",
        "/inventoryPlanning/dailyTrackerKpi/new",
        "/analytics/vendorSalesReport",
        "/analytics/vendorSalesStockItemReport",
        "/analytics/retailerPivotalSizeReport",
        "/analytics/retailerSalesCogsReport",
        "/analytics/salesReportNew",
        "/analytics/channel/wise/daily/sales/report",
        "/analytics/abcAssortmentAnalysis",
        "/analytics/freshStockAndDiscountStock"
    ],
    "purchaseReportsStack": [
        "/inventoryPlanning/grn/report",
        "/analytics/opsreport",
        "/analytics/dispatchreport",
        "/analytics/retailerPoReport",
        "/analytics/entPurchaseReport",
        "/analytics/potogrnreport",
        "/analytics/multiLevelApprovalLogs",
        "/analytics/tnaorderstatus",
        // "/vendor/analytics/tnaorderstatus",
        "/analytics/poGrnException",
        '/analytics/otb/forcaste/report',
        '/analytics/orderReport',
        '/analytics/vendorPoItemReport',
        "/analytics/otbReport",
        "/analytics/top/selling/product",
        "/analytics/vendorPoReport",
        "/analytics/vendorPoToGrnReport",
        "/vendor/analytics/tnaorderstatus",
        "/analytics/order/request/report",
        "/analytics/custom/sales/grc/report",
        "/analytics/tnaAnalysisDashboard",
        "/analytics/poSyncMonitoring",
        "/analytics/otbBudgetVsActualReport",
        "/analytics/custom/pending/purchase/order/report",
        "/analytics/otbLogs"
    ],
    "accoutingReportStack": [
        "/analytics/retailerLedgerReport",
        "/analytics/retailerOutstandingReport",
        "/analytics/customerOutstandingReport",
        "/analytics/customerLedgerReport"
    ],
    "stockReportsStack": [
        "/analytics/retailerStockReport",
        "/salesManagement/stockDrrMisReport",
        "/analytics/stockagingReport",
        '/analytics/vendorStockReport',
        "/analytics/stockagingReportV2",
        "/analytics/custom/stock/point/report"
    ],
    "logisticsReportsStack": [
        "/mdm/factoryaddressreport",
        "/analytics/logisticsPaymentReconciliation",
        "/analytics/appointmentReport",
        "/analytics/logisticsInventoryReport",
        "/analytics/retailerLrReport"
    ],
    "adminReportsStack": [
        "/vendor/loginLogoutReport",
        "/vendor/activityReport"
    ],
    "shipmentReportsStack": [
        // "/analytics/autoAsnReport",
        "/analytics/shipmentBoxReport",
        "/analytics/retailerInspectionReport",
        "/analytics/retailerAsnReport",
        "/analytics/autoAsnReport",
        "/analytics/vendorInspectionReport",
        "/analytics/vendorAsnReport"
    ]
}

export const stacksV2 = {
    // Administration Stack
    "ADMIN": {
        "administrationStack": [
            "/administration/rolesMaster/manageRoles",
            "/app/data/settings/users",
            "/app/data/settings/users/data",
            "/administration/organisation",
            "/app/data/settings/logs/data",
            "/app/data/settings/logs/api",
            "/app/data/settings/system/mails",
            "/app/data/settings/config/global",
            "/administration/rolesMaster/createRoles",
            "/app/data/settings/roles",
            "/administration/organization/architecture",
            "/administration/departmentConfiguration"
        ]
    },
    // Master Data Stack
    "MDM": {
        "masterDataStack": [
            "/mdm/manageVendors",
            "/app/data/master/vendors/",
            "/app/data/master/item",
            "/mdm/manage/set",
            "/app/data/master/agent",
            "/app/data/master/transporter",
            "/app/data/master/material/library",
            "/app/data/master/fabric",
            "/app/data/master/cost/sheet",
            "/app/data/master/customer",
            "/mdm/manageSalesAgents",
            "/app/data/master/site/",
            "/app/data/master/mailinglist",
            "/app/data/master/catdesc",
            "/app/data/master/hsn",
            "/app/data/master/hsn/create",
            "/app/data/master/itemhierarchy",
            "/app/data/master/itemhierarchy/create",
            "/app/data/master/marginrule",
            "/app/data/master/marginrule/create",
            "/app/data/master/articlemaster",
            "/app/data/master/articlemaster/create"
        ]
    },
    // Sales Management Retailer Stack
    "DIGISALES": {
        "salesOrderStack": [
            "/app/product/digisales/b/sales/orders/create",
            "/app/product/digisales/b/sales/orders",
            "/app/product/digisales/b/manage/sales/agents",
            "/app/product/digisales/b/manage/customers",
            "/app/product/digisales/b/manage",
            "/app/product/digisales/b/manage/pricelist",
            "/app/product/digisales/b/delivery/challan",
            "/core/custom/upload/digisales",
            "/salesManagement/createPricelist",
            "/salesManagement/bag",
            "/core/custom/upload/digisales",
        ],
        ...reportStack
    },
    // Super Admin Stack
    "RSUPERADM": {
        "superAdminStack": [
            "/mdm/support-tickets",
            "/mdm/users",
            "/mdm/enterprisesPortal"
        ]
    },

    // Customer Sales Order Route
    "CDIGISALES": {
        "customerSalesOrderStack": [
            "/app/product/digisales/c/sales/orders/create",
            "/app/product/digisales/c/sales/orders",
            "/salesManagement/bag",
        ],
        ...reportStack
    },

    // vendor side digivend
    "DIGIVEND": {
        "grievanceStack": [
            "/app/product/grievance/create",
            "/app/product/grievance"
        ],
        "digivendStack": [
            "/app/product/digivend/purchase/orders/pending",
            "/app/product/digivend/grievance/create",
            "/app/product/digivend/grievances",
            "/vendor/purchaseOrder/processedOrders",
            "/vendor/purchaseOrder/cancelledOrders",
            "/app/product/digivend/shipment",
            "/app/product/digivend/shipment",
            "/app/product/digivend/shipment/asn/approved",
            "/app/product/digivend/shipment",
            "/app/product/digivend/shipment/asn/processing",
            "/vendor/logistics/goodsIntransit",
            "/app/product/digivend/purchase/goods/received",
            "/vendor/logistics/grcStatus",
            "/vendor/vendorSearchComment",
            "/vendor/orderRequest",
            "/vendor/discrepancy",
            "/vendor/vendorBillDiscounting",
            "/vendor/request/onboarding",
            "/vendor/salesInvoice",
            "/app/product/digivend/finance/ledger",
            "/app/product/digivend/logistics/transit",
            "/app/product/digivend/shipment",
            '/app/product/digivend/purchase/orders/request',
            "/app/product/digivend/finance/transactions",
            '/app/product/digivend/finance/inbound/discrepancies',
            "/core/custom/upload/vdigivend",
            "/app/product/digivend/finance/payment/requests",
            "/app/product/digivend/finance/return/to/vendor",
            "/app/product/digivend/service/order",
            "/app/product/digivend/trf"
        ],
        "digicatStack": [
            "/app/product/digiproc/products/create",
            "/app/product/digiproc/purchase/product/create",
            "/app/product/digivend/products",
            "/app/product/digivend/sales/indents",
            "/app/product/digivend/sales/indents/create",
            "/app/product/digivend/purchase/product/create",
            "/catalogue/costSheet/library",
            "/catalogue/fabric/library",
        ],
        // Vendor Reports & Analytics
        ...{
            "salesReportsStack": [
                "/analytics/vendorSalesReport",
                "/analytics/vendorSalesStockItemReport",
                "/analytics/salesReportNew"
            ],
            "shipmentReportsStack": [
                "/analytics/vendorInspectionReport",
                "/analytics/vendorAsnReport",
                "/analytics/shipmentBoxReport"
            ],
            "purchaseReportsStack": [
                "/analytics/vendorPoReport",
                "/analytics/vendorPoToGrnReport",
                "/vendor/analytics/tnaorderstatus",
                "/analytics/order/request/report",
                "/analytics/top/selling/product",
                "/analytics/custom/sales/grc/report",
                "/analytics/tnaAnalysisDashboard"
            ],
            "stockReportsStack": [
                "/analytics/retailerStockReport",
                "/salesManagement/stockDrrMisReport",
                "/analytics/stockagingReport",
                '/analytics/vendorStockReport'
            ],
            "accoutingReportStack": [
                "/analytics/vendorLedgerReport"
            ],
            "logisticsReportsStack": [
                "/analytics/vendorLrReport",
            ],
        },

    },

    // ARS Stack
    "DIGIARS": {
        "replenishmentStack": [
            "/inventoryPlanning/order",
            "/inventoryPlanning/summary",
            "/app/product/allokator/orders/history",
            "/app/product/allokator/run/replenishment",
            "/app/product/allokator/summary",
            "/app/product/allokator/replenishment",
            "/app/product/allokator/salesforecast"
            // "/analytics/plannerWorkQueue2"
        ],
        "planningSettingStack": [
            "/app/product/allokator/assortments",
            "/inventoryPlanning/season-mapping",
            "/inventoryPlanning/inventoryAutoConfig",
            "/app/product/allokator/mapping/site",
            "/inventoryPlanning/event-mapping",
            // "/inventoryPlanning/mrp-range"
        ],
        "digiArsStack": [
            "/app/product/allokator/requests/adhoc",
            "/core/custom/upload/digiars",
            "/app/product/allokator/orders/planning"
        ],
        ...reportStack
    },

    // Retailer DigiProc 
    "DIGIPROC": {
        "grievanceStack": [
            "/app/product/grievance",
            "/app/product/grievance-config/create"
        ],
        "digiProcStack": [
            "/digiproc/createOrder",
            "/digiproc/createIndent",
            "/app/product/digiproc/purchase/indents",
            "/app/product/digiproc/purchase/orders",
            "/purchase/viewpr",
            "/digiproc/excelUploadHistory",
            '/app/product/digiproc/manage/plan/otb',
            "/app/product/digiproc/manage/range/mrp",
            '/digiproc/fabricConsumptionLogs',
            '/digiproc/create/fabricNomination',
            '/app/product/digiproc/purchase/fabric/nominations',
            '/core/custom/upload/digiproc',
            '/app/product/digiproc/purchase/indents/create',
            '/app/product/digiproc/purchase/orders/create',
            '/app/product/digiproc/manage/recommendation/engine',
            '/app/product/digiproc/service/order',
            '/app/product/digiproc/master/cost/sheet',
            '/app/product/digiproc/purchase/orders/raise'
        ],
        "digivendStack": [
            "/app/product/digivend/grievance/create",
            "/app/product/digivend/grievances",
            "/enterprise/purchaseOrder/pendingOrders",
            "/enterprise/purchaseOrder/processedOrders",
            "/enterprise/purchaseOrder/cancelledOrders",
            "/app/product/digiproc/shipment",
            "/enterprise/logistics/lrProcessing",
            "/app/product/digiproc/logistics/transit",
            "/app/product/digiproc/purchase/grc/pending",
            "/enterprise/logistics/grcStatus",
            "/enterprise/vendorSearchComment",
            "/enterprise/orderRequest",
            "/enterprise/vendorInvoices",
            "/app/product/digiproc/finance/payment/requests",
            "/app/product/digiproc/shipment/quality/check/pending",
            "/enterprise/qualityCheck/cancelledInspection",
            "/app/product/digiproc/manage/config/autoasn",
            "/app/product/digiproc/manage/appointment",
            "/app/product/digiproc/manage/config/po",
            "/app/product/digiproc/manage/tempate/boxratio",
            "/core/custom/upload/digivend",
            "/digivend/searchComment",
            "/app/product/digiproc/finance/transactions",
            '/app/product/digiproc/finance/inbound/discrepancies',
            '/app/product/digiproc/finance/return/to/vendor',
            '/app/product/digiproc/trf'
        ],
        // Digicatalogue Stack
        "digicatStack": [
            "/productCatalogue/addProducts",
            "/catalogue/products/viewProducts",
            "/app/product/digiproc/products/view",
            "/productCatalogue/addProducts",
            "/catalogue/products/requested/products",
            "/catalogue/products/historyV2",
            "/catalogue/productSurvey/view",
            "/catalogue/retailer/survey/create",
            "/catalogue/retailer/survey/view",
            "/catalogue/productSurvey/feedback/view",
            "/app/product/digiproc/products/create",
            "/app/product/digiproc/purchase/product/create",
            "/app/product/digiproc/purchase/product/survey/create",
            "/app/product/digiproc/purchase/product/survey/view",
            "/app/product/digiproc/purchase/product/survey/feedback/view",
        ],
        // Retailer Reports & Analytics
        // Admin Retailer Reports.
        ...reportStack,
    },
}

export const stackNamesV2 = {
    "replenishmentStack": ReplenishmentStack,
    "planningSettingStack": PlanningSettingStack,
    "digiArsStack": DigiArsStack,
    "administrationStack": AdministrationStack,
    "masterDataStack": MasterDataStack,
    "salesOrderStack": SalesOrderStack,
    "superAdminStack": SuperAdminStack,
    "adminReportsStack": AdminReportsStack,
    "shipmentReportsStack": ShipmentReportsStack,
    "digivendStack": DigivendStack,
    "replenishmentReportsStack": ReplenishmentReportsStack,
    "inventoryManagementReportsStack": InventoryManagementReportsStack,
    "salesReportsStack": SalesReportsStack,
    "purchaseReportsStack": PurchaseReportsStack,
    "accoutingReportStack": AccountingReportsStack,
    "stockReportsStack": StockReportsStack,
    "logisticsReportsStack": LogisticsReportsStack,
    "customerSalesOrderStack": SalesOrderStack,
    "digiProcStack": DigiProcStack,
    "grievanceStack" : GrievanceStack,
    "digicatStack": DigiCatStack,
    "customerReportStack": CustomerReportStack,
}
